<template>
    <div class="page-header">
        <AppHeader gap="''">
            <template #titleLeft>
                <nav class="text-gray-700" aria-label="Breadcrumb">
                    <ol class="list-none p-0 inline-flex font-semibold">
                        <li class="flex items-center">
                            <router-link to="/transforms" class="text-green-500 hover:text-cyan-900">Transforms</router-link>
                            <ChevronRightIcon class="w-4 h-4 mx-2 text-cyan-950" />
                        </li>
                    </ol>
                </nav>
            </template>
            <template #titleRight>
                <small
                    class="ml-2 inline-flex items-center rounded-full px-2.5 font-medium py-0.5 bg-blue-100 text-blue-800 shadow-sm text-xs"
                    >BETA</small
                >
            </template>
        </AppHeader>
    </div>
    <AppLoader :force-loading="transformsConfigLoading" :default-height="'70vh'">
        <CreateTransformsList
            v-if="transformsStore.configs"
            :transform-groups="transformsStore.configs"
            @select-transform="(item) => selectItem(item)" />
    </AppLoader>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CreateTransformsList from '@/components/Transforms/CreateTransformsList.vue';
import { useTransformsStore } from '@/stores/transforms.store';
import AppHeader from '../../components/AppHeader.vue';
import AppLoader from '@/components/AppLoader.vue';
import { ChevronRightIcon } from '@heroicons/vue/24/solid';

const router = useRouter();
const transformsStore = useTransformsStore();

const transformsConfigLoading = ref(false);

onMounted(async () => {
    try {
        transformsConfigLoading.value = true;

        transformsStore.fetchTransformConfigs().finally(() => {
            transformsConfigLoading.value = false;
        });
    } catch (error) {
        console.error('Error fetching transforms config', error);
    }
});

const selectItem = (child) => {
    router.push({ name: 'create-transform-type', params: { transformType: child.transform } });
};
</script>
